<div class="h-full flex flex-col justify-start items-center overflow-hidden space-y-4">
    <!-- Header -->
    <div
        class="flex-0 flex flex-row items-center justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-2">

        <div class="flex flex-row items-center gap-x-2">
            <button type="button" (click)="showHelpModal.set(true)"
                class="inline-flex items-center gap-x-1.5 secondary-button text-primary">
                What is Screening?
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="-mr-0.5 size-5">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                    <path d="M12 17h.01" />
                </svg>
            </button>
            @if (selectedTab() === 'screening-briefs') {
            <div class="grid grid-cols-1">
                <input [formField]="searchQueryForm.query" id="brief-search" type="text"
                    placeholder="Screening Brief Search" class="input-icon text-primary" />
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-500 sm:size-4">
                    <path d="m21 21-4.34-4.34" />
                    <circle cx="11" cy="11" r="8" />
                </svg>
            </div>
            }
        </div>


        <div class="flex flex-row items-center gap-x-2">

            <div class="px-1 py-1 dark:bg-white/10 bg-gray-100 rounded-full flex flex-row items-center gap-x-1">
                <button type="button" (click)="selectTab('screening-briefs')" position="left"
                    class="rounded-full text-sm py-1 px-2 hover:bg-primary/85 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                    [class]="selectedTab() === 'screening-briefs' ? 'bg-primary text-white' : 'bg-transparent text-gray-500 dark:text-gray-400'">
                    Screening Briefs
                </button>
                <button type="button" position="right" (click)="selectTab('creator-lists')"
                    class="rounded-full text-sm py-1 px-2 hover:bg-primary/85 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                    [class]="selectedTab() === 'creator-lists' ? 'bg-primary text-white' : 'bg-transparent text-gray-500 dark:text-gray-400'">
                    Creator Lists
                </button>
            </div>


            <div class="inline-flex rounded-md">
                <button type="button" (click)="showAddNewDropdown.set(!showAddNewDropdown())"
                    class="relative inline-flex items-center rounded-l-md bg-primary dark:bg-primary px-3 py-2 text-sm font-semibold text-white inset-ring-1 inset-ring-zinc-300 dark:inset-ring-white/10 hover:bg-primary/90 dark:hover:bg-primary/90 focus:z-10 focus:outline-hidden">Add
                    New...</button>
                <el-dropdown [open]="showAddNewDropdown()" class="relative -ml-px block">
                    <button (click)="showAddNewDropdown.set(!showAddNewDropdown())"
                        class="relative inline-flex items-center rounded-r-md bg-primary dark:bg-primary px-2 py-2 text-white inset-ring-1 inset-ring-zinc-300 dark:inset-ring-white/10 hover:bg-primary/90 dark:hover:bg-primary/90 focus:z-10 cursor-pointer">
                        <span class="sr-only">Open options</span>
                        <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="size-5">
                            <path
                                d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
                                clip-rule="evenodd" fill-rule="evenodd" />
                        </svg>
                    </button>
                    <el-menu anchor="bottom end" popover [open]="showAddNewDropdown()"
                        class="ml-1 w-56 origin-top-right rounded-md dark:bg-gray-800 bg-gray-100 outline-1 -outline-offset-1 outline-white/10 transition transition-discrete [--anchor-gap:--spacing(2)] data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in shadow-md">
                        <div class="py-1">

                            <a (click)="newCreatorList()"
                                class="w-full px-4 py-2 text-sm text-primary focus:bg-white/5 focus:text-primary focus:outline-hidden cursor-pointer inline-flex items-center gap-x-1.5 dark:hover:bg-primary/90 hover:bg-primary">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-4">
                                    <path
                                        d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
                                    <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                                    <path d="M9 15h6" />
                                    <path d="M12 18v-6" />
                                </svg>
                                New Creator List</a>

                            <a (click)="newScreeningBrief()"
                                class="w-full px-4 py-2 text-sm text-primary focus:bg-white/5 focus:text-primary focus:outline-hidden cursor-pointer inline-flex items-center gap-x-1.5 dark:hover:bg-primary/90 hover:bg-primary">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-4">
                                    <path
                                        d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
                                    <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                                    <path d="M10 12.5 8 15l2 2.5" />
                                    <path d="m14 12.5 2 2.5-2 2.5" />
                                </svg>
                                New Screening Brief</a>
                        </div>
                    </el-menu>
                </el-dropdown>
            </div>
        </div>


    </div>
    <!-- Header - END -->

    <!-- Content -->

    @switch (selectedTab()) {
    @case ('creator-lists') {
    <div class="flex-1 flex flex-col justify-start items-center overflow-hidden w-full">
        <div class="h-full flex-1 w-full overflow-y-auto scrollbar-transparent">
            @if (allLists() && allLists().length > 0) {
            <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                @for (list of allLists(); track list.id) {
                <div class="rounded-lg bg-white/60 dark:bg-white/5 p-4 outline-1 -outline-offset-1 outline-zinc-200 dark:outline-white/10 hover:outline-2 hover:-outline-offset-2 hover:outline-primary cursor-pointer transition-all"
                    (click)="viewList(list)">
                    <div class="flex items-start gap-x-3">
                        <div
                            class="size-10 shrink-0 rounded-lg bg-gray-100 dark:bg-gray-800 flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                                class="size-5 text-gray-600 dark:text-gray-400">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                <circle cx="9" cy="7" r="4" />
                                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                            </svg>
                        </div>
                        <div class="flex-1 min-w-0">
                            <h3 class="text-sm font-semibold text-primary truncate">{{ list.groupName }}</h3>
                            <p class="mt-1 text-xs text-secondary">
                                {{ list.numberOfCreators || 0 }} {{ (list.numberOfCreators || 0) === 1 ? 'creator' :
                                'creators' }}
                            </p>
                            @if (list.groupDescription) {
                            <p class="mt-1 text-xs text-secondary line-clamp-2">{{ list.groupDescription }}</p>
                            }
                            <p class="mt-2 text-xs text-secondary">
                                {{ formatListDate(list) }}
                            </p>
                        </div>
                        <div class="shrink-0 flex items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="size-5 text-gray-400 dark:text-gray-500">
                                <path d="m9 18 6-6-6-6" />
                            </svg>
                        </div>
                    </div>
                </div>
                }
            </div>
            } @else {
            <div class="h-full flex items-center justify-center">
                <div class="text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                        class="mx-auto size-12 text-gray-400">
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                        <circle cx="9" cy="7" r="4" />
                        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                    <h3 class="mt-4 text-sm font-semibold text-primary">No creator lists yet</h3>
                    <p class="mt-2 text-sm text-secondary">Get started by creating your first creator list.</p>
                </div>
            </div>
            }
        </div>
    </div>
    }
    @case ('screening-briefs') {
    <div class="flex-1 flex flex-col justify-start items-center overflow-hidden w-full">
        <div class="h-full flex-1 w-full overflow-x-auto overflow-y-hidden scrollbar-transparent">
            <div class="flex flex-row h-full gap-4 min-w-max">

                <!-- Waiting For Creators Column -->
                <div
                    class="flex flex-col h-full w-80 shrink-0 bg-gray-100 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                    <div class="shrink-0 px-4 py-2 border-b border-gray-200 dark:border-gray-700">
                        <div class="flex items-center flex-row gap-x-2">
                            <div
                                class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                                1
                            </div>
                            <div class="">
                                <h3 class="text-sm font-semibold text-primary">Waiting For Creators</h3>
                            </div>
                        </div>
                    </div>
                    <div
                        class="flex-1 overflow-y-auto p-2 space-y-3 transition-colors duration-200 scrollbar-transparent">
                        @if (notReadyBriefs() && notReadyBriefs().length > 0) {
                        <div class="grid grid-cols-1 gap-y-2">
                            @for (brief of notReadyBriefs(); track $index) {
                            <sb-kanban-card [brief]="brief"></sb-kanban-card>
                            }
                        </div>
                        } @else {
                        <div class="h-full flex items-center justify-center text-gray-400 text-sm">
                            Drop screening briefs here
                        </div>
                        }
                    </div>
                </div>
                <!-- Waiting For Creators Column - END -->

                <!-- Analysing Screening Brief Column -->
                <div
                    class="flex flex-col h-full w-80 shrink-0 bg-gray-100 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                    <div class="shrink-0 px-4 py-2 border-b border-gray-200 dark:border-gray-700">
                        <div class="flex items-center flex-row gap-x-2">
                            <div
                                class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                                2
                            </div>
                            <div class="">
                                <h3 class="text-sm font-semibold text-primary">Analysing Screening Brief</h3>
                            </div>
                        </div>
                    </div>
                    <div
                        class="flex-1 overflow-y-auto p-2 space-y-3 transition-colors duration-200 scrollbar-transparent">
                        @if (processingBriefs() && processingBriefs().length > 0) {
                        <div class="grid grid-cols-1 gap-y-2">
                            @for (brief of processingBriefs(); track $index) {
                            <sb-kanban-card [brief]="brief"></sb-kanban-card>
                            }
                        </div>
                        }
                        @else if (processingBriefs() && processingBriefs().length == 0) {
                        <div class="h-full flex items-center justify-center text-gray-400 text-sm">
                            Drop screening briefs here
                        </div>
                        } @else {
                        <div class="w-full h-full flex items-center justify-center">
                            <div class="text-center">
                                <svg class="mx-auto size-16 text-accent" viewBox="0 0 57 60"
                                    xmlns="http://www.w3.org/2000/svg" stroke="hsl(228, 97%, 42%)">
                                    <g fill="none" fill-rule="evenodd">
                                        <g transform="translate(1 1)" stroke-width="3">
                                            <circle cx="5" cy="50" r="5">
                                                <animate attributeName="cy" begin="0s" dur="2.2s" values="50;5;50;50"
                                                    calcMode="linear" repeatCount="indefinite" />
                                                <animate attributeName="cx" begin="0s" dur="2.2s" values="5;27;49;5"
                                                    calcMode="linear" repeatCount="indefinite" />
                                            </circle>
                                            <circle cx="27" cy="5" r="5">
                                                <animate attributeName="cy" begin="0s" dur="2.2s" from="5" to="5"
                                                    values="5;50;50;5" calcMode="linear" repeatCount="indefinite" />
                                                <animate attributeName="cx" begin="0s" dur="2.2s" from="27" to="27"
                                                    values="27;49;5;27" calcMode="linear" repeatCount="indefinite" />
                                            </circle>
                                            <circle cx="49" cy="50" r="5">
                                                <animate attributeName="cy" begin="0s" dur="2.2s" values="50;50;5;50"
                                                    calcMode="linear" repeatCount="indefinite" />
                                                <animate attributeName="cx" from="49" to="49" begin="0s" dur="2.2s"
                                                    values="49;5;27;49" calcMode="linear" repeatCount="indefinite" />
                                            </circle>
                                        </g>
                                    </g>
                                </svg>

                            </div>
                        </div>
                        }
                    </div>
                </div>
                <!-- Analysing Screening Brief Column - END -->

                <!-- Refinement Column -->
                <div
                    class="flex flex-col h-full w-80 shrink-0 bg-gray-100 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                    <div class="shrink-0 px-4 py-2 border-b border-gray-200 dark:border-gray-700">
                        <div class="flex items-center flex-row gap-x-2">
                            <div
                                class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                                3
                            </div>
                            <div class="">
                                <h3 class="text-sm font-semibold text-primary">Refinement</h3>
                            </div>
                        </div>
                    </div>
                    <div
                        class="flex-1 overflow-y-auto p-2 space-y-3 transition-colors duration-200 scrollbar-transparent">
                        @if (refinementBriefs() && refinementBriefs().length > 0) {
                        <div class="grid grid-cols-1 gap-y-2">
                            @for (brief of refinementBriefs(); track $index) {
                            <sb-kanban-card [brief]="brief"></sb-kanban-card>
                            }
                        </div>
                        } @else if (refinementBriefs() && refinementBriefs().length == 0) {
                        <div class="h-full flex items-center justify-center text-gray-400 text-sm">
                            Drop screening briefs here
                        </div>
                        } @else {
                        <div class="w-full h-full flex items-center justify-center">
                            <div class="text-center">
                                <svg class="mx-auto size-16 text-accent" viewBox="0 0 57 60"
                                    xmlns="http://www.w3.org/2000/svg" stroke="hsl(228, 97%, 42%)">
                                    <g fill="none" fill-rule="evenodd">
                                        <g transform="translate(1 1)" stroke-width="3">
                                            <circle cx="5" cy="50" r="5">
                                                <animate attributeName="cy" begin="0s" dur="2.2s" values="50;5;50;50"
                                                    calcMode="linear" repeatCount="indefinite" />
                                                <animate attributeName="cx" begin="0s" dur="2.2s" values="5;27;49;5"
                                                    calcMode="linear" repeatCount="indefinite" />
                                            </circle>
                                            <circle cx="27" cy="5" r="5">
                                                <animate attributeName="cy" begin="0s" dur="2.2s" from="5" to="5"
                                                    values="5;50;50;5" calcMode="linear" repeatCount="indefinite" />
                                                <animate attributeName="cx" begin="0s" dur="2.2s" from="27" to="27"
                                                    values="27;49;5;27" calcMode="linear" repeatCount="indefinite" />
                                            </circle>
                                            <circle cx="49" cy="50" r="5">
                                                <animate attributeName="cy" begin="0s" dur="2.2s" values="50;50;5;50"
                                                    calcMode="linear" repeatCount="indefinite" />
                                                <animate attributeName="cx" from="49" to="49" begin="0s" dur="2.2s"
                                                    values="49;5;27;49" calcMode="linear" repeatCount="indefinite" />
                                            </circle>
                                        </g>
                                    </g>
                                </svg>

                            </div>
                        </div>
                        }
                    </div>
                </div>
                <!-- Refinement Column - END -->

                <!-- Screening Column -->
                <div
                    class="flex flex-col h-full w-80 shrink-0 bg-gray-100 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                    <div class="shrink-0 px-4 py-2 border-b border-gray-200 dark:border-gray-700">
                        <div class="flex items-center flex-row gap-x-2">
                            <div
                                class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                                4
                            </div>
                            <div class="">
                                <h3 class="text-sm font-semibold text-primary">Screening</h3>
                            </div>
                        </div>
                    </div>
                    <div
                        class="flex-1 overflow-y-auto p-2 space-y-3 transition-colors duration-200 scrollbar-transparent">
                        @if (screeningBriefs() && screeningBriefs().length > 0) {
                        <div class="grid grid-cols-1 gap-y-2">
                            @for (brief of screeningBriefs(); track $index) {
                            <div>
                                <h2>{{ brief.briefTitle }}</h2>
                            </div>
                            }
                        </div>
                        } @else if (screeningBriefs() && screeningBriefs().length == 0) {
                        <div class="h-full flex items-center justify-center text-gray-400 text-sm">
                            Drop screening briefs here
                        </div>
                        } @else {
                        <div class="w-full h-full flex items-center justify-center">
                            <div class="text-center">
                                <svg class="mx-auto size-16 text-accent" viewBox="0 0 57 60"
                                    xmlns="http://www.w3.org/2000/svg" stroke="hsl(228, 97%, 42%)">
                                    <g fill="none" fill-rule="evenodd">
                                        <g transform="translate(1 1)" stroke-width="3">
                                            <circle cx="5" cy="50" r="5">
                                                <animate attributeName="cy" begin="0s" dur="2.2s" values="50;5;50;50"
                                                    calcMode="linear" repeatCount="indefinite" />
                                                <animate attributeName="cx" begin="0s" dur="2.2s" values="5;27;49;5"
                                                    calcMode="linear" repeatCount="indefinite" />
                                            </circle>
                                            <circle cx="27" cy="5" r="5">
                                                <animate attributeName="cy" begin="0s" dur="2.2s" from="5" to="5"
                                                    values="5;50;50;5" calcMode="linear" repeatCount="indefinite" />
                                                <animate attributeName="cx" begin="0s" dur="2.2s" from="27" to="27"
                                                    values="27;49;5;27" calcMode="linear" repeatCount="indefinite" />
                                            </circle>
                                            <circle cx="49" cy="50" r="5">
                                                <animate attributeName="cy" begin="0s" dur="2.2s" values="50;50;5;50"
                                                    calcMode="linear" repeatCount="indefinite" />
                                                <animate attributeName="cx" from="49" to="49" begin="0s" dur="2.2s"
                                                    values="49;5;27;49" calcMode="linear" repeatCount="indefinite" />
                                            </circle>
                                        </g>
                                    </g>
                                </svg>

                            </div>
                        </div>
                        }
                    </div>
                </div>
                <!-- Screening Column - END -->

                <!-- Complete Column -->
                <div
                    class="flex flex-col h-full w-80 shrink-0 bg-gray-100 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                    <div class="shrink-0 px-4 py-2 border-b border-gray-200 dark:border-gray-700">
                        <div class="flex items-center flex-row gap-x-2">
                            <div
                                class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                                5
                            </div>
                            <div class="">
                                <h3 class="text-sm font-semibold text-primary">Complete</h3>
                            </div>
                        </div>
                    </div>
                    <div
                        class="flex-1 overflow-y-auto p-2 space-y-3 transition-colors duration-200 scrollbar-transparent">
                        @if (completeBriefs() && completeBriefs().length > 0) {
                        <div class="grid grid-cols-1 gap-y-2">
                            @for (brief of completeBriefs(); track $index) {
                            <sb-kanban-card [brief]="brief"></sb-kanban-card>
                            }
                        </div>
                        }@else if (completeBriefs() && completeBriefs().length == 0) {
                        <div class="h-full flex items-center justify-center text-gray-400 text-sm">
                            Drop screening briefs here
                        </div>
                        } @else {
                        <div class="w-full h-full flex items-center justify-center">
                            <div class="text-center">
                                <svg class="mx-auto size-16 text-accent" viewBox="0 0 57 60"
                                    xmlns="http://www.w3.org/2000/svg" stroke="hsl(228, 97%, 42%)">
                                    <g fill="none" fill-rule="evenodd">
                                        <g transform="translate(1 1)" stroke-width="3">
                                            <circle cx="5" cy="50" r="5">
                                                <animate attributeName="cy" begin="0s" dur="2.2s" values="50;5;50;50"
                                                    calcMode="linear" repeatCount="indefinite" />
                                                <animate attributeName="cx" begin="0s" dur="2.2s" values="5;27;49;5"
                                                    calcMode="linear" repeatCount="indefinite" />
                                            </circle>
                                            <circle cx="27" cy="5" r="5">
                                                <animate attributeName="cy" begin="0s" dur="2.2s" from="5" to="5"
                                                    values="5;50;50;5" calcMode="linear" repeatCount="indefinite" />
                                                <animate attributeName="cx" begin="0s" dur="2.2s" from="27" to="27"
                                                    values="27;49;5;27" calcMode="linear" repeatCount="indefinite" />
                                            </circle>
                                            <circle cx="49" cy="50" r="5">
                                                <animate attributeName="cy" begin="0s" dur="2.2s" values="50;50;5;50"
                                                    calcMode="linear" repeatCount="indefinite" />
                                                <animate attributeName="cx" from="49" to="49" begin="0s" dur="2.2s"
                                                    values="49;5;27;49" calcMode="linear" repeatCount="indefinite" />
                                            </circle>
                                        </g>
                                    </g>
                                </svg>

                            </div>
                        </div>
                        }
                    </div>
                </div>
                <!-- Complete Column - END -->

            </div>
        </div>
    </div>
    }
    }


    <!-- Content - END -->
</div>

@if (showHelpModal()) {
<screening-help (close)="showHelpModal.set(false)"></screening-help>
}
@if (socialScreeningService.showSelectCreatorList() && socialScreeningService.focussedScreeningBriefSignal()) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-6"
    (click)="socialScreeningService.showSelectCreatorList.set(false)">
    <div class="h-[70vh] w-full max-w-2xl overflow-hidden rounded-xl bg-white p-4 dark:bg-gray-900"
        (click)="$event.stopPropagation()">
        <rg-group-picker class="h-full w-full" [mode]="'attach-to-brief'"
            [briefContext]="{ kind: 'screening', briefId: socialScreeningService.focussedScreeningBriefSignal()!.id }"
            (attached)="socialScreeningService.showSelectCreatorList.set(false)"></rg-group-picker>
    </div>
</div>
}